import { Seo } from "../components/Seo";
import { Header } from "../components/Header";
import { WhereToBuy } from "../components/WhereToBuy";
import { Footer } from "../components/Footer";

export default function WhereToBuyPage() {
  return (
    <main data-testid="where-to-buy-page">
      <Seo title={"Where to Buy PhudG Cold-Pressed Oils | Shop Online"} description={"Find where to buy PhudG cold-pressed mustard, groundnut and sunflower oils online and discover our available retail and delivery options."} image="/images/hero-table.jpg" path="/where-to-buy" />
      <Header />
      <section className="bg-ink grain relative pt-36 pb-16 overflow-hidden">
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10">
          <p className="text-xs tracking-[0.4em] uppercase text-gold mb-4">Where to Buy</p>
          <h1 className="font-serif text-5xl md:text-7xl text-cream tracking-tighter max-w-3xl">
            However you <span className="italic text-gold">shop.</span>
          </h1>
          <p className="mt-8 max-w-xl text-base font-light text-cream/65 leading-relaxed">
            Online marketplaces, quick commerce, or straight from us on
            WhatsApp — pick what works for your kitchen.
          </p>
        </div>
      </section>
      <WhereToBuy />
      <Footer />
    </main>
  );
}
